const containerWidth = 1170;

export default containerWidth;
